(() => {
  // Delegation also works when Shopify replaces a section in the theme editor.
  let opener;
  const text = (tag, value, className) => {
    const node = document.createElement(tag);
    node.textContent = value;
    if (className) node.className = className;
    return node;
  };
  const filter = (scope, kind) => {
    if (!scope) return;
    const cards = [...scope.querySelectorAll('.product-card')];
    for (const card of cards) card.hidden = kind !== 'all' && card.dataset.kind !== kind;
    scope.querySelectorAll('[data-premium-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.premiumFilter === kind)));
    const count = scope.querySelector('[data-premium-count]');
    if (count) count.textContent = `${cards.filter(card => !card.hidden).length} on display`;
  };
  document.addEventListener('click', event => {
    const target = event.target.closest('button,a');
    if (!target) return;
    if (target.matches('.mobile-menu a')) target.closest('details').open = false;
    if (target.hasAttribute('data-premium-filter')) filter(target.closest('[data-premium-collection]'), target.dataset.premiumFilter);
    if (target.hasAttribute('data-premium-category')) {
      const scope = document.getElementById('products');
      if (scope?.querySelector('[data-premium-filter]')) filter(scope, target.dataset.premiumCategory);
      scope?.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
    }
    const dialog = document.getElementById('premium-dialog');
    if (!dialog) return;
    if (target.hasAttribute('data-premium-close')) { dialog.close(); return; }
    const productId = target.dataset.premiumProduct;
    const topic = target.dataset.premiumInfo;
    if (!productId && !topic) return;
    opener = target;
    const title = dialog.querySelector('#premium-dialog-title');
    const content = dialog.querySelector('.dialog-content');
    content.replaceChildren();
    if (productId) {
      const catalog = JSON.parse(document.getElementById('premium-reference-data').textContent);
      const product = catalog.find(item => item.id === productId);
      if (!product) return;
      title.textContent = product.name;
      const row = document.createElement('div'); row.className = 'detail-product';
      const photo = document.createElement('img'); photo.src = product.image; photo.alt = `${product.name} original product reference photo`;
      const copy = document.createElement('div');
      copy.append(text('p', product.category, 'eyebrow'), text('h3', product.name), text('p', product.description), text('p', 'Price to be confirmed', 'detail-disclaimer'), text('p', 'Visual reference only. Names are placeholders. Brand, model, AI features, language support, connectivity and pricing are not yet confirmed. Not available for purchase.', 'detail-disclaimer'));
      row.append(photo, copy); content.append(row);
    } else {
      const info = {
        features: ['Features & experience', 'Verified product pages will explain features, interactions and limitations. These reference images do not confirm AI capabilities.'],
        language: ['Language & connectivity', 'Language support, connectivity and required apps are listed for each product.'],
        shipping: ['Shipping & delivery', 'Free shipping on US orders. Orders are dispatched within 48 hours. Estimated delivery to the United States is 7–10 business days after dispatch. Processing time is separate from transit time. Shipping charges and delivery options for other countries will be confirmed before launch.'],
        returns: ['Returns & warranty', "For TuanTuan AI Plush Cat, you may request a refund within 7 days of delivery for a quality defect not caused by you. We review your order and the information about the issue before approving a claim. Approved refunds do not require you to send the product back and are issued to the original payment method. Our one-year limited warranty runs from delivery and covers quality defects arising during normal use that are not caused by you. After verifying a covered fault, we prioritize replacement and cover the necessary return and replacement shipping costs. Replacement products carry a six-month limited warranty from delivery of the replacement. Change-of-mind refunds and customer-caused damage, including damage from drops or misuse, are not covered by this voluntary policy. This does not limit your rights under applicable law. Contact service1302026@163.com with your order number. Read the refund and warranty policy for full details."],
        contact: ['Contact us', 'Email service1302026@163.com for customer support.'],
        privacy: ['Privacy policy', 'Our privacy policy is being prepared. This is a preview link.'],
        terms: ['Terms of service', 'Our terms of service are being prepared. This is a preview link.']
      }[topic];
      if (!info) return;
      title.textContent = info[0]; content.append(text('p', info[1]), text('p', 'Design preview · Details to be confirmed', 'info-note'));
    }
    dialog.showModal();
  });
  document.addEventListener('close', event => { if (event.target.id === 'premium-dialog') opener?.focus(); }, true);
  document.addEventListener('click', event => {
    if (event.target.id !== 'premium-dialog') return;
    const bounds = event.target.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
  });
})();
